// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eja7","option":"styles_option__1KNUw","active":"styles_active__1YsqF"};